import { render } from "./equity.vue?vue&type=template&id=1895909a"
import script from "./equity.vue?vue&type=script&lang=js"
export * from "./equity.vue?vue&type=script&lang=js"

import "./equity.vue?vue&type=style&index=0&id=1895909a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__